/**
 * Prepare privacy policy markdown (docs/PRIVACY_POLICY.md → agent-ui/src/content) for display.
 * Strips doc metadata and version history; public-facing content starts at Introduction.
 */

const INTRO_HEADING = '## Introduction'

/**
 * @param {string} raw
 * @returns {{ lastUpdated: string, body: string }}
 */
export function preparePrivacyPolicyMarkdown(raw) {
  const lastUpdatedMatch = raw.match(/\*\*Last Updated:\*\*\s*(.+)/i)
  const lastUpdated = lastUpdatedMatch?.[1]?.trim() ?? ''

  const introIndex = raw.indexOf(`\n${INTRO_HEADING}`)
  const body =
    introIndex >= 0 ? raw.slice(introIndex + 1).trimStart() : raw.trim()

  return { lastUpdated, body }
}
